module.exports = __webpack_public_path__ + "static/img/4.b35aaca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R404A/4.jpg
// module id = wBK/
// module chunks = 1